var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 20 20"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M3 9.25a.75.75 0 0 0 0 1.5h14a.75.75 0 1 0 0-1.5z"}})])
}
var staticRenderFns = []

export default { render: render }